import { render } from "./DownloadLiquidation.vue?vue&type=template&id=d6c67108"
import script from "./DownloadLiquidation.vue?vue&type=script&lang=js"
export * from "./DownloadLiquidation.vue?vue&type=script&lang=js"

import "./DownloadLiquidation.vue?vue&type=style&index=0&id=d6c67108&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__